// Bildirim → admin route derin-link çözümü. Eşleşmezse null (no-op).
//
// entityRef semantiği (BE NotificationDispatcher): Article/Page/Campaign için
// SLUG, SssItem için id, Form için submissionId taşınır. Admin edit route'ları
// (`/articles/:id` vb.) `:id` beklediğinden slug'ı param olarak geçmek kırık URL
// üretir — bu yüzden yalnız id taşıyan SssItem editöre; içerikler liste sayfasına
// gider. WorkflowSubmitted alıcıları onaylayıcılar olduğundan onları doğrudan
// onay kuyruğuna yönlendiririz (her zaman geçerli + eyleme dönük).

import { ROUTES } from '@shared/constants/routes';
import type { AppNotification } from './types';

export function notificationRoute(
  n: Pick<AppNotification, 'type' | 'entityType' | 'entityRef'>,
): string | null {
  if (n.type === 'WorkflowSubmitted') return ROUTES.WORKFLOW_QUEUE;

  switch (n.entityType.toLowerCase()) {
    case 'sss':
      return n.entityRef ? ROUTES.SSS_EDIT.replace(':id', n.entityRef) : ROUTES.SSS;
    case 'article':
      return ROUTES.ARTICLES;
    case 'page':
      return ROUTES.PAGES;
    case 'campaign':
      return ROUTES.CAMPAIGNS;
    case 'form':
      return ROUTES.FORMS;
    default:
      return null;
  }
}
